import RestService from './RestService';
import { ApiRoutes } from './apiRoutes';

export type ModelPortfolioInstrument = {
  isin: string;
  nome_strumento: string | null;
  tipo_strumento: string | null;
  valuta: string | null;
  peso: number;
};

export type ModelPortfolioAllocation = {
  azionario: number;
  obbligazionario: number;
  monetario: number;
  altro: number;
};

export type ModelPortfolioPlan = {
  financial_plan: number;
  code: string;
  portfolio_name: string;
  allocation: ModelPortfolioAllocation;
  instruments: ModelPortfolioInstrument[];
};

export type ModelPortfolioFamily = { portfolio_type: string; plans: ModelPortfolioPlan[] };

export const ModelPortfoliosService = {
  getAll: async (): Promise<{ families: ModelPortfolioFamily[] }> => RestService.get(ApiRoutes.MODEL_PORTFOLIOS),
};
